enum ProfileTypes {
  Admin = 1,
  Client = 2,
  VenueEditor = 3,
  SplashEditor = 4,
}

export default ProfileTypes;
